module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "800px",
      "persistent": "",
      "transition": "scale-transition",
      "max-height": "600px"
    },
    model: {
      value: (_vm.openDialog),
      callback: function($$v) {
        _vm.openDialog = $$v
      },
      expression: "openDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "overflow": "hidden",
      "display": "block"
    }
  }, [(_vm.item) ? _c('v-layout', {
    attrs: {
      "id": "resource-modal"
    }
  }, [_c('v-flex', {
    staticClass: "resource-main",
    staticStyle: {
      "height": "600px",
      "overflow-y": "scroll"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    staticClass: "secondary",
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "resource_content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "resource-details-actions secondary"
  }, [_c('h2', {
    staticClass: "py-4 px-4 resource-title text-sm-center white--text"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-4": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "pt-1": "",
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("access_time")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("actualDate")(_vm.item.submitdate)))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "white--text",
    attrs: {
      "pt-1": "",
      "sm4": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("list_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.category))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "white--text",
    attrs: {
      "pt-1": "",
      "sm4": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "color": "white"
    }
  }, [_vm._v("fa-tags")]), _vm._v(" "), _vm._l((_vm.item.tags), function(tag, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(tag)), (index + 1 < _vm.item.tags.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pt-2 post_img resource-media"
  }, [(_vm.item.media.id) ? _c('iframe', {
    attrs: {
      "src": _vm.item.media.embedUrl,
      "allowfullscreen": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.item.media,
      "alt": "Agency Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "px-4 py-4 description resource-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-card-actions', {
    staticStyle: {
      "position": "relative",
      "bottom": "25px",
      "width": "100%"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-1 pt-1 mx-4 text-xs-center",
    attrs: {
      "justify-space-around": ""
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "activator",
      "small": "",
      "secondary--text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-layout', {
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "secondary--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("favorite")])], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "activator",
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-layout', {
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "color": "red"
    }
  }, [_vm._v("favorite")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "link": _vm.link
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04e686ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/info/resourceViewModal.vue
// module id = 1215
// module chunks = 11 18